<script lang="ts">
  export type SemaforoData = {
    totalCamas?: number;
    ocupadas?: number;
    disponibles?: number;
    tasaOcupacionPct?: number;
    porColor?: Record<string, number>;
    porEstado?: Record<string, number>;
    porServicio?: Record<string, Record<string, number> | number>;
  };

  let {
    data = null as SemaforoData | null,
    compact = false,
    showTables = true,
  }: {
    data?: SemaforoData | null;
    compact?: boolean;
    showTables?: boolean;
  } = $props();

  function formatoServicio(n: Record<string, number> | number): string {
    if (typeof n === 'number') return String(n);
    return Object.entries(n).map(([k, v]) => `${k}: ${v}`).join(' · ');
  }
</script>

{#if data}
  <div class="grid" class:compact>
    <div class="card verde"><h3>Disponibles</h3><p class="big">{data.porColor?.verde ?? 0}</p></div>
    <div class="card amarillo"><h3>Limpieza / asignadas</h3><p class="big">{data.porColor?.amarillo ?? 0}</p></div>
    <div class="card rojo"><h3>Ocupadas</h3><p class="big">{data.porColor?.rojo ?? 0}</p></div>
    <div class="card gris"><h3>Mantenimiento</h3><p class="big">{data.porColor?.gris ?? 0}</p></div>
    <div class="card total">
      <h3>{compact ? 'Ocupación' : 'Total camas'}</h3>
      <p class="big">{compact ? `${data.tasaOcupacionPct ?? 0}%` : (data.totalCamas ?? 0)}</p>
      {#if compact && data.totalCamas != null}
        <small>{data.ocupadas ?? 0} / {data.totalCamas}</small>
      {/if}
    </div>
  </div>

  {#if showTables && !compact}
    <h4>Por servicio</h4>
    <table>
      <thead><tr><th>Servicio</th><th>Detalle</th></tr></thead>
      <tbody>
        {#each Object.entries(data.porServicio ?? {}) as [svc, n]}
          <tr>
            <td>{svc}</td>
            <td>{formatoServicio(n)}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  {/if}
{/if}

<style>
  .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 0.75rem; margin: 0.5rem 0 1rem; }
  .grid.compact { grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); }
  .card { padding: 0.85rem 1rem; border-radius: var(--radius-md); color: #fff; }
  .card h3 { margin: 0; font-size: 0.82rem; font-weight: 500; opacity: 0.92; }
  .card .big { margin: 0.35rem 0 0; font-size: 2rem; font-weight: 800; line-height: 1; }
  .card small { opacity: 0.9; font-size: 0.72rem; }
  .verde { background: var(--kpi-verde); }
  .amarillo { background: var(--kpi-amarillo); color: #3a2a00; }
  .rojo { background: var(--kpi-rojo); }
  .gris { background: var(--kpi-gris); }
  .total { background: linear-gradient(135deg, var(--kpi-total), var(--brand-deep)); }
  h4 { margin: 1rem 0 0.5rem; font-size: 0.95rem; color: #166534; }
  table { width: 100%; border-collapse: collapse; margin-bottom: 0.5rem; }
  th { padding: 0.55rem 0.8rem; background: #f0fdf4; color: #6b7280; text-transform: uppercase; letter-spacing: 0.03em; font-size: 0.7rem; text-align: left; }
  td { padding: 0.45rem 0.8rem; border-top: 1px solid #f3f4f6; text-align: left; font-size: 0.85rem; color: #111827; }
</style>
